var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-list grid grid__base" }, [
    _c("div", { staticClass: "payment-list--container grid--container" }, [
      _c(
        "div",
        { staticClass: "payment-list--row payment-list--header-row grid--row" },
        [
          _c(
            "div",
            { staticClass: "payment-list--title-col grid--col" },
            [_vm._t("title")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "payment-list--filter-col grid--col" },
            [
              _c("form-field-select", {
                staticClass: "payment-list--filter",
                attrs: {
                  facets: ["base", "secondary-select"],
                  items: _vm.transformedOptions,
                  "auto-filter": _vm.autoFilter
                },
                model: {
                  value: _vm.selectedFilter,
                  callback: function($$v) {
                    _vm.selectedFilter = $$v
                  },
                  expression: "selectedFilter"
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "u-reset payment-list--list grid--row" },
        _vm._l(_vm.filteredListItems, function(item, idx) {
          return _c(
            "li",
            { key: item.hash_id, staticClass: "payment-list--item grid--col" },
            [
              _c(
                "payment-method",
                _vm._b(
                  {
                    staticClass: "payment-list--method",
                    attrs: {
                      "next-item": _vm.getNextItem(idx),
                      "item-id": item.hash_id,
                      facets: [_vm.disableOverlays ? null : "clickable"],
                      "overlay-disabled": _vm.disableOverlays
                    },
                    on: { registered: _vm.onOverlayRegistered }
                  },
                  "payment-method",
                  item,
                  false
                )
              )
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffdb9e4a", { render: render, staticRenderFns: staticRenderFns })
  }
}